<div class="r-panel">
    <div class="panel-title">
        <span>{{stepNumber}}</span>
        <p>{{'select.game' | translate}}</p>
    </div>
    <div class="r-panel-ctn">
        @for (game of games; track $index) {
            <div class="r-panel-item" >
                <button
                    matRipple
                    [matRippleCentered]="rippleOptions.centered"
                    [matRippleDisabled]="rippleOptions.disabled"
                    [matRippleUnbounded]="rippleOptions.unbounded"
                    [matRippleRadius]="rippleOptions.radius"
                    [matRippleColor]="rippleOptions.color"
                    (click)="selectGames(game)">
                    <img src="images/png/games/{{game.code}}.png" class="img-responsive" alt={{game.name}}>
                </button>
            </div>
        }
      </div>
    </div>
